import { Route, Routes } from 'react-router-dom'
import { Navigate } from 'react-router'
import { AccountAccessLayout } from 'pages/settings/pages/personal/pages/account/layout/AccountAccessLayout'
import { AccountLayout } from 'pages/settings/pages/personal/pages/account/layout/AccountLayout'
import { ProfilePage } from 'pages/settings/pages/personal/pages/account/pages/profile'
import { SecurityPage } from 'pages/settings/pages/personal/pages/account/pages/security'
import { PersonalRoutes } from 'pages/settings/pages/personal'
import { VoicemailDropPage } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop'

export const AccountRouter = () => {
  return (
    <Routes>
      <Route element={<AccountAccessLayout />}>
        <Route element={<AccountLayout />}>
          <Route path={`${PersonalRoutes.profile}`} element={<ProfilePage />} />
          <Route path={`${PersonalRoutes.security}`} element={<SecurityPage />} />
          <Route path={`${PersonalRoutes.voicemailDrop}`} element={<VoicemailDropPage />} />
          <Route index element={<Navigate to={`${PersonalRoutes.profile}`} replace />} />
          <Route path='*' element={<Navigate to={`${PersonalRoutes.profile}`} replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
